import {cs}               from "@Common/react/chain-services";
import {fragments}        from "@Common/react/fragments";
import {Invoke}           from "@Common/react/invoke";
import {loadScript}       from "@Common/ui-components/browser/load-script";
import {isDevQuan}        from "@Common/ui-components/debug/is-dev-quan";
import {isXdQaTagsViewer} from "@Common/ui-components/debug/is-xd-qa-tags-viewer";

export const loadDevTools = ({next}) => cs(
    () => fragments(
        next(),
        isDevQuan() || localStorage.XD_QA_TAGS_VIEWER_LOCAL ? Invoke({
            action: () => loadScript({src: "http://localhost:3989/index.js", id: "qa-tags-viewer"}),
        }) : isXdQaTagsViewer() && Invoke({
            action: () => import("@Common/tools/qa-tags-viewer/client/index.tsx"),
        }),
    ),
);
